import styled from 'styled-components';
import { Man } from './icons/Man';
import { Woman } from './icons/Woman';
import { Carousel } from 'antd';


export const ManSvg = styled(Man)`

`   
export const WomanSvg = styled(Woman)`
    
`


export const CarouselTestimonios = styled(Carousel)`
    & > ul.slick-dots-bottom{
        position: unset !important;
        height: 17vh;

        @media screen and (max-width: 1500px) {
            height: 15vh;
        }
    
        @media screen and (max-width: 768px) {
            height: 10vh;
        }

        & > li {
            opacity: 0.4;
            width: unset !important;
        }

        & > li.slick-active{
            opacity: unset;
        }
    }
`

export const DivImage = styled.div`
    display: grid; 
    width: 17vh;

    @media screen and (max-width: 1500px) {
        width: 15vh;
    }

    @media screen and (max-width: 768px) {
        width: 9vh;
    }
`

export const Div = styled.div`
    text-align: center;
    height: 40vh;
    padding: 4vh;
    font-style: italic;
    font-size: 25px;
`

export const DivTitle = styled.div`
    text-align: center;
    padding: 3vh;
    color: #C24728;
    font-size: 100%;
    display: contents;
`

export const Title = styled.h1`
    color: #C24728;
`